import { useNavigation } from "@/composables/useNavigation";
import { useIndividStore } from "@/stores";


export function composeAnstalldarendeUrl(arendeId: number | string) {
  const individStore = useIndividStore();
  const navigation = useNavigation();
  const { path, query } = navigation.currentRoute;
  return `${location.protocol}//${location.host}${path}?id=${query.id}&ver=${individStore.verification.isVerified}&manver=${individStore.verification.isManuallyVerified}&ticket_id=${arendeId}`;
}
